import styled from 'styled-components';
import {theme} from '@styles/theme';
import {SwitcherProps} from '@atoms/Switcher';

export const SwitcherWrapper = styled.div<{checked?: boolean}>`
  display: flex;
  align-items: center;
`;

export const SwitcherBlock = styled.div<SwitcherProps>`
  position: relative;
  width: 38px;
  height: 20px;
  background-color: ${({checked}) =>
    checked ? theme.colors.accent00 : theme.colors.basic04};
  border-radius: ${theme.roundedBig};
  margin-right: ${({label}) => (label ? '10px' : 0)};
  cursor: pointer;
  transition: 0.2s all linear;
  &:after {
    position: absolute;
    content: '';
    top: 3px;
    left: ${({checked}) => (checked ? '21px' : '3px')};
    width: 14px;
    height: 14px;
    background-color: ${theme.colors.basic08};
    border-radius: ${theme.roundedBig};
    transition: 0.2s all linear;
  }
`;
